<template>
  <v-dialog fullscreen v-model="show" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar class="secondary" dark>
        <v-toolbar-title> {{ $t('media.upload.carica') }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-layout>
          <v-flex>
            <v-card ref="drop" :color="dropAreaBackground" flat height="87vh" class="border-25px">
              <v-container fluid fill-height>
                <v-layout align-center justify-center fill-height>
                  <v-flex class="text-xs-center">
                    <v-layout v-if="status === 0" justify-center>
                      <v-flex xs6 md3>
                        <div class="subheading">
                          <v-icon>mood_bad</v-icon> {{ $t('media.upload.errore') }}
                        </div>
                        <v-btn color="primary" class="mt-3" @click.prevent="$router.go()">{{
                          $t('media.upload.cta2')
                        }}</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="status === 1" justify-center>
                      <v-flex xs6 md3>
                        <v-select
                          v-model="license"
                          :label="$t('media.upload.licenza')"
                          :items="licenses"
                        />
                        <div class="mb-3">{{ $t('media.upload.then') }}</div>
                        <h1>
                          {{ $t('media.upload.drag') }}<br /><span class="subheading">{{
                            $t('media.upload.or')
                          }}</span>
                        </h1>
                        <v-btn
                          color="primary"
                          class="mt-3"
                          ref="buttonAdd"
                          @click.prevent=""
                          :disabled="license == null"
                          >{{ $t('media.upload.tooltip') }}</v-btn
                        >
                        <h4 class="top-spacing text-sm-left">
                          <div class="flex-center">
                            <span class="material-symbols-outlined mx-2"> info </span>
                            <div class="align-center">
                              {{ $t('media.upload.msg1') }}<br />
                              {{ $t('media.upload.formati1') }} <br />
                              {{ $t('media.upload.formati2') }}<br />
                              {{ $t('media.upload.formati3') }}
                            </div>
                          </div>
                        </h4>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-center v-if="status === 2">
                      <v-flex xs6 md4>
                        <h1 v-if="files.length > 0">{{ $t('media.upload.caricamento') }}</h1>
                        <h1 v-else-if="uploaded.length > 0 ">{{ $t('media.upload.complete') }}</h1>
                        <template v-for="(file, index) in files">
                          <v-list-tile :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title class="body-2">
                                <span class="font-weight-bold">{{ file.progress }}%</span> -
                                {{ file.name | truncate(40) }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                <v-progress-linear
                                  height="10"
                                  v-model="file.progress"
                                  :color="file.progress < 100 ? 'primary' : 'success'"
                                />
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                        <template>
                          <v-layout>
                            <v-flex xs12 sm6 offset-sm3>
                              <v-container grid-list-sm fluid>
                                <v-layout row wrap>
                                  <v-flex v-for="(file, index) in uploaded" :key="index" xs4 d-flex>
                                    <v-card flat tile class="d-flex">
                                      <v-img
                                        :src="file.url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        gradient="to top right, rgba(0,0,0,.4), rgba(0,0,0,.4)"
                                      >
                                        <template v-slot:placeholder>
                                          <v-layout fill-height align-center justify-center ma-0>
                                            <v-progress-circular
                                              indeterminate
                                              color="grey lighten-5"
                                            ></v-progress-circular>
                                          </v-layout>
                                        </template>

                                        <!-- Overlay with centered green checkmark -->
                                        <v-overlay :value="true" absolute>
                                          <v-layout
                                            fill-height
                                            align-center
                                            justify-center
                                            class="white--text"
                                          >
                                            <v-icon
                                              color="green lighten-2"
                                              x-large
                                              class="white--text"
                                            >
                                              check_circle
                                            </v-icon>
                                          </v-layout>
                                        </v-overlay>
                                      </v-img>
                                    </v-card>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </template>
                      </v-flex>
                    </v-layout>
                    <div v-if="status == 2">
                      <h1 class="mt-2" v-if="invalid.length > 0 && uploaded == 0">{{ $t('media.upload.warning') }}</h1>
                      <h3 class="mt-2" v-else-if="invalid.length > 0 && uploaded != 0">{{ $t('media.upload.warning') }}</h3>
                      <div
                        v-for="(element, index) in invalid"
                        :key="index"
                        xs4
                        class="d-flex justify-center mb-2"
                      >
                        <v-card style="max-width: 400px" class="mt-4" variant="tonal">
                          <v-card-text>
                            <div class="d-flex">
                              <v-icon
                                x-large
                                class="white--text"
                                style="cursor: pointer; height: fit-content"
                                color="red"
                              >
                                highlight_off
                              </v-icon>
                              <span class="ml-3" style="text-align: left">
                                <h3 style="color: red; font-weight: bold">
                                  {{ $t('media.upload.errorTitle') }}
                                </h3>
                                <b>{{ element.name | truncate(40) }} </b>
                                <br />
                                {{ element.error }}
                              </span>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                    <v-btn class="mt-4" v-if="status == 2" color="primary" @click="closeArea">{{
                      $t('media.upload.procedi')
                    }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Dropzone from 'dropzone';
import _remove from 'lodash/remove';
import _find from 'lodash/find';
import _difference from 'lodash/difference';
import _differenceBy from 'lodash/differenceBy';
import { $EventBus } from '@/eventBus';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    type: {
      // tipo: immagine, video o raw
      type: Array, // ['image', 'video']
      required: true,
      validator: (v) => _difference(['image', 'video', 'raw', 'pdf'], v).length === 4 - v.length,
    },
    multiple: {
      // se accetta valori multipli
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    dropArea: null,
    uploadUrl: `https://api.cloudinary.com/v1_1/${process.env.VUE_APP_CLOUDINARY_CLOUD_NAME}/upload`,
    uploadPreset: process.env.VUE_APP_CLOUDINARY_UPLOAD_PRESET,
    status: 1, // 0: errore, 1: in attesa, 2: in caricamento
    files: [], // file in upload
    uploaded: [], // file caricati
    invalid: [],
    saved: [], // file salvati sul db
    savedCounter: 0, // contatore di quelli salvati
    dragover: false, // sto trascinando
    imageMaxFileSize: 1000000, // massima dimensione per immagini
    pdfMaxFileSize: 2000000, // massima dimensione per pdf/allegati
    videoMaxFileSize: 4000000, // massima dimensione per video
    license: null,
    licenses: [
      { value: 'N', text: 'All rights reserved - Tutti i diritti riservati.' },
      { value: 'PD', text: 'Public domain (*CC0) - Dominio pubblico, libero uso.' },
      { value: 'U', text: 'Unsplash license - da unsplash.com, senza attribuzione.' },
      { value: 'A', text: 'Attribution (CC BY) - Attribuzione' },
      {
        value: 'AS',
        text: 'Attribution-ShareAlike (CC BY-SA) - Attribuzione - Condividi allo stesso modo',
      },
      { value: 'AND', text: 'Attribution-NoDerivs (CC BY-ND): Attribuzione - non opere derivate ' },
      {
        value: 'ANC',
        text: 'Attribution-NonCommercial (CC BY-NC): Attribuzione - Non commerciale',
      },
      {
        value: 'ANCS',
        text: 'Attribution-NonCommercial-ShareAlike (CC BY-NC-SA): Attribuzione – Non Commerciale – Condividi allo Stesso Modo',
      },
      {
        value: 'ANCND',
        text: 'Attribution-NonCommercial-NoDerivs (CC BY-NC-ND): Attribuzione – Non Commerciale – Non Opere Derivate',
      },
    ],
  }),
  computed: {
    dropAreaBackground() {
      if (this.status >= 2) {
        return 'white';
      } else {
        if (this.dragover) {
          return 'accent';
        } else {
          return 'grey lighten-2';
        }
      }
    },
    acceptedTypes() {
      const types = [];
      if (this.type.includes('image')) {
        types.push(process.env.VUE_APP_IMAGE_UPLOAD_PERMITTED_EXTENSIONS);
      }
      if (this.type.includes('video')) {
        types.push(process.env.VUE_APP_VIDEO_UPLOAD_PERMITTED_EXTENSIONS);
      }
      if (this.type.includes('pdf') || this.type.includes('raw')) {
        types.push(process.env.VUE_APP_RAW_UPLOAD_PERMITTED_EXTENSIONS);
        types.push('pdf');
      }
      return types.join(',');
    },
    allTypes() {
      return `${process.env.VUE_APP_IMAGE_UPLOAD_PERMITTED_EXTENSIONS},${process.env.VUE_APP_VIDEO_UPLOAD_PERMITTED_EXTENSIONS},${process.env.VUE_APP_RAW_UPLOAD_PERMITTED_EXTENSIONS}`;
    },
  },
  methods: {
    getFileName(file) {
      return file.replace(/\.[^/.]+$/, '');
    },
    getFileExtension(file) {
      return file.split('.').pop();
    },
    closeArea() {
      this.$emit('close');
      this.destroyArea();
    },
    initArea() {
      this.dropArea = new Dropzone(this.$refs.drop.$el, {
        acceptedFiles: this.acceptedTypes,
        maxFiles: !this.multiple ? 1 : 10000000,
        url: this.uploadUrl,
        createImageThumbnails: false,
        parallelUploads: 10,
        timeout: 10000000,
        uploadMultiple: false,
        clickable: this.$refs.buttonAdd.$el,
      });
      this.dropArea.on('dragover', () => {
        this.dragover = true;
      });
      this.dropArea.on('dragend', () => {
        this.dragover = false;
      });
      this.dropArea.on('dragleave', () => {
        this.dragover = false;
      });
      this.dropArea.on('drop', () => {
        this.dragover = false;
      });

      // Listener che viene triggerato quando viene droppato un file nella drop area
      this.dropArea.on('addedfiles', (files) => {
        this.dropped_media = 2;
        files.forEach((file) => {
          let ext = file.type.split('/')[0]; // Estrai il tipo di file
          let format = file.type.split('/')[1]; // Estrai il formato specifico

          // Verifica la presenza di licenza
          if (this.license != null) {
            // Controlla se il file soddisfa le condizioni di estensione e dimensione
            if (
              (ext === 'image' && file.size < this.imageMaxFileSize) || // Immagine sotto il limite
              (ext === 'application' && file.size < this.pdfMaxFileSize) || // PDF sotto il limite
              (ext === 'video') &&  file.size < this.videoMaxFileSize
            ) {
              // Controlla il formato specifico per le immagini
              if (ext === 'image' && (format === 'heic' || format === 'heif')) {
                this.dropArea.removeFile(file); // Rimuove il file HEIC/HEIF
                this.invalid.push({
                  name: file.name,
                  error: this.$t('error.media.format'),
                });
                $EventBus.$emit('message', {
                  type: 'error',
                  text: this.$t('error.media.format'),
                });
              } else {
                // Aggiungi file valido alla lista
                this.files.push({
                  _id: file.upload.uuid,
                  name: file.name,
                  progress: 0,
                });
              }
            } else {
              // Se non rispetta le dimensioni o le condizioni, rimuovilo
              this.dropArea.removeFile(file);
              this.invalid.push({
                name: file.name,
                error: this.$t('error.media.size'),
              });
              $EventBus.$emit('message', {
                type: 'error',
                text: this.$t('error.media.size'),
              });
            }
          } else {
            // Se non c'è licenza, rimuovi il file e mostra errore
            this.dropArea.removeFile(file);
            this.invalid.push({
              name: file.name,
              error: this.$t('error.media.license'),
            });
            $EventBus.$emit('message', {
              type: 'error',
              text: this.$t('error.media.license'),
            });
          }
        });
        if(this.files.length == 0) {
          this.status = 2;
        }
      });

      this.dropArea.on('sending', (file, xhr, formData) => {
        this.status = 2;
        xhr.ontimeout = function (err) {
          console.log(err);
          this.dropArea.removeFile(file);
          $EventBus.$emit('message', {
            type: 'error',
            text: this.$t('error.media.timeout'),
          });
        };
        // Verifica se la licenza è presente
        if (this.license != null) {
          formData.append('upload_preset', this.uploadPreset);
        } else {
          // Se non c'è una licenza, blocca l'invio del file
          xhr.abort(); // Interrompi la richiesta
          $EventBus.$emit('message', {
            type: 'error',
            text: this.$t('error.media.license'), // Errore se non c'è licenza
          });
        }
      });

      this.dropArea.on('success', (file, response) => {
        response.filename = file.name;
        this.uploaded.push(response); // aggiungi a quelli caricati
        file.previewElement.innerHTML = ''; // nascondi la preview di dropzone
        _remove(this.files, (f) => f._id === file.upload.uuid); // togli dalla lista quello completato
        if (!this.files.length) {
          // se non ce ne sono più, ha finito, salva sul nostro db
          this.savedCounter = 0;
          this.uploaded.forEach(async (u, i) => {
            try {
              u.title = this.getFileName(u.filename); // di default
              u.description = this.getFileName(u.filename); // di default
              u.extension = this.getFileExtension(u.filename); // si sa mai
              u.license = this.license;
              const savedRecord = await this.$http.post(`/media/${u.public_id}`, u); // salva su oracle
              this.saved.push(savedRecord.data);
              this.savedCounter++;
              if (this.savedCounter === this.uploaded.length) {
                this.$emit('uploaded', this.saved);
                if(this.invalid == 0) {
                  this.closeArea();
                }
                $EventBus.$emit('message', {
                  type: 'success',
                  text: this.$t('success.media.uploaded'),
                });
              }
            } catch (err) {
              console.log(err);
              this.status = 0;
              const notSavedOnDb = _differenceBy(this.uploaded, this.saved, (i) => i.public_id);
              console.log(notSavedOnDb);
              $EventBus.$emit('message', {
                type: 'error',
                text: this.$t('error.media.upload'),
              });
            }
          });
        }
      });
      this.dropArea.on('error', (file, errorMessage) => {
        this.status = 0;
        if (errorMessage.indexOf('You can not upload any more files') !== -1) {
          errorMessage = 'Puoi caricare solo un file';
          this.status = 1;
        }
        if (errorMessage.indexOf("You can't upload files of this type") !== -1) {
          errorMessage = this.$t('error.media.type');
          if (!this.files.length) {
            this.status = 1;
          }
        }
        console.log('upload error', errorMessage);
        $EventBus.$emit('message', { type: 'error', text: errorMessage });
      });
      this.dropArea.on('uploadprogress', (file, progress, bytesSent) => {
        _find(this.files, (f) => f._id === file.upload.uuid).progress = parseInt(progress); // attacca la percentuale al file in caricamento
      });
    },
    destroyArea() {
      this.status = 1;
      this.dropArea.destroy();
      this.dropArea = null;
      this.savedCounter = 0;
      this.uploaded = [];
      this.invalid = [];
      this.saved = [];
      this.license = null;
    },
  },
  watch: {
    show: function (open) {
      if (open) {
        this.initArea();
      } else {
        this.destroyArea();
        this.$emit('close');
      }
    },
  },
};
</script>

<style>
.border-25px {
  border-radius: 25px;
}

.flex-vertical {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.dz-preview {
  display: none;
}

.top-spacing {
  margin-top: 2rem;
}
</style>
